<section class="playground">
  <h2 class="playground__heading">Title preview</h2>
  <p class="playground__hint">
    <code>common-title-preview</code> — título h4 con icono de edición opcional.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>value</span>
        <input type="text" [(ngModel)]="value" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showEditIcon" />
        <span>showEditIcon</span>
      </label>

      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option value="large">large</option>
          <option value="small">small</option>
        </select>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-title-preview
          [size]="size"
          [value]="value"
          [showEditIcon]="showEditIcon"
          (edit)="onEdit()"
        ></common-title-preview>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
